import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  LocationIcon,
  PhoneIcon,
  MailIcon,
  WebsiteIcon,
  YoutubeIcon,
  FacebookIcon,
} from './icon';
import { getShareInfoSelector } from '@store/common/selectors';
import { useMediaQuery } from 'react-responsive';
// import mayBottom from "../../../Modules/Pricing/assets/may-bottom.png";
// import hitaDesktop from "../../../Modules/Pricing/assets/hita-desktop.png";
// import book from "../../../Modules/Pricing/assets/book.png";

import { FacebookIconFooter, YoutubeIconFooter } from '../../../assets/svg';

const Footer = () => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const formData = useSelector((state) => getShareInfoSelector(state));

  return (
    <footer className="footer-area">
      {/* <img className="mayBottom-img" alt="" src={mayBottom} /> */}
      {/* <img className="hitaDesktopBottom-img" alt="" src={hitaDesktop} /> */}
      {/* <img className="bookBottom-img" alt="" src={book} /> */}
      <div className="bg-image">
        <div className="container">
          <div className="d-flex logo__content">
            <div>
              <a
                onClick={() =>
                  window.open('https://tamtriluc.com/', '_blank').focus()
                }
                className="logo"
              >
                <img
                  src={require('@src/assets/images/logo-ttl.png').default}
                  alt="tamtriluc"
                />
              </a>
            </div>
            <div style={{ marginLeft: 24 }}>
              <a
                onClick={() =>
                  window.open('https://5phutthuocbai.com/', '_blank').focus()
                }
                className="logo"
              >
                <img
                  src={require('@src/assets/images/logo-white.png').default}
                  alt="stnhd"
                />
              </a>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="single-footer-widget">
                <div className="about__content">
                  <div className="about__title">
                    <span>
                      CÔNG TY CỔ PHẦN ĐÀO TẠO <br />
                      TÂM TRÍ LỰC
                    </span>
                  </div>
                  <div className="about__main">
                    <ul>
                      <li>
                        <div className="about__main-item">
                          <div className="about__main-item-icon light_label">
                            MST
                          </div>
                          <div className="about__main-item-content">
                            <span>0314866590</span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="about__main-item">
                          <div className="about__main-item-icon">
                            <LocationIcon />
                          </div>
                          <div className="about__main-item-content">
                            <span>
                              Địa chỉ trên GPKD: Lầu 1, 170-170bis Bùi Thị Xuân,
                              Phường Phạm Ngũ Lão, Quận 1, TPHCM
                            </span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="about__main-item">
                          <div className="about__main-item-icon">
                            <LocationIcon />
                          </div>
                          <div className="about__main-item-content">
                            <span>
                              778/11 Nguyễn Kiệm, Phường 4, Quận Phú Nhuận, Tp
                              HCM
                            </span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="about__main-item">
                          <div className="about__main-item-icon">
                            <PhoneIcon />
                          </div>
                          <div className="about__main-item-content">
                            <span>0939 279 868</span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="about__main-item">
                          <div className="about__main-item-icon">
                            <MailIcon />
                          </div>
                          <div className="about__main-item-content">
                            <span>cskh@tamtriluc.com</span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="about__main-item">
                          <div className="about__main-item-icon">
                            <WebsiteIcon />
                          </div>
                          <div className="about__main-item-content">
                            <span>5phutthuocbai.com</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`col-lg-3 col-md-6 col-6 col-sm-6 ${
                isDesktop && 'd-flex flex-row justify-content-center'
              }`}
            >
              <div className="single-footer-widget pl-5">
                <div className="menu__title">{t('FOOTER:aboutUs')}</div>

                <ul className="list">
                  <li>
                    <Link to="/">{t('FOOTER:home')}</Link>
                  </li>
                  <li>
                    <Link to="/introduce">{t('FOOTER:introduce')}</Link>
                  </li>
                  <li>
                    <Link to="/teachers">{t('FOOTER:teachers')}</Link>
                  </li>
                  <li>
                    <Link to="/news">{t('FOOTER:news')}</Link>
                  </li>
                  <li>
                    <Link to="/contact">{t('FOOTER:contact')}</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className={`col-lg-3 col-md-6 col-6 col-sm-6 ${
                isDesktop && 'd-flex flex-row justify-content-center'
              }`}
            >
              <div className="single-footer-widget">
                <div className="menu__title">{t('FOOTER:policy')}</div>

                <ul className="list">
                  <li>
                    <Link to="/support">{t('FOOTER:support')}</Link>
                  </li>
                  <li>
                    <Link to="/help/buy-guide">{t('FOOTER:buyGuide')}</Link>
                  </li>
                  <li>
                    <Link to="/help/payment-term">{t('FOOTER:buyTerm')}</Link>
                  </li>
                  <li>
                    <Link to="/help/private-policy">
                      {t('FOOTER:privatePolicy')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/help/complain-policy">
                      {t('FOOTER:complainPolicy')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/help/return-policy">
                      {t('FOOTER:returnPolicy')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/help/license">{t('FOOTER:license')}</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="single-footer-widget">
                <div className="menu__title">{t('FOOTER:workTime')}</div>

                <ul className="list">
                  <li>
                    <div className="work__time">
                      <div className="work__time-day">
                        {t('FOOTER:monToFri')}
                      </div>
                      <div className="work__time-hour">: 8h00 - 19h00</div>
                    </div>
                  </li>
                  <li>
                    <div className="work__time">
                      <div className="work__time-day">
                        {t('FOOTER:saturday')}
                      </div>
                      <div className="work__time-hour">: 8h00 - 17h00</div>
                    </div>
                  </li>
                  <li>
                    <div className="work__time">
                      <div className="work__time-day">{t('FOOTER:sunday')}</div>
                      <div className="work__time-hour">: 8h00 - 15h00</div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="cursor-pointer"
                      onClick={() =>
                        window.open(
                          'http://online.gov.vn/Home/WebDetails/90490?AspxAutoDetectCookieSupport=1'
                        )
                      }
                    >
                      <img
                        width="190"
                        src={
                          require('@src/assets/images/thongbaocongthuong.png')
                            .default
                        }
                        alt="Bo-cong-thuong"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="gcn-bottom">
        <div className="container">
          <div
            className={`row ${
              isTablet || isMobile ? 'flex-column-reverse' : ''
            }`}
          >
            <div className="col-12 col-sm-12 col-md-9 col-lg-9">
              <div className="gcn-bottom__title">
                © 2020 Tâm Trí Lực Giấy chứng nhận Đăng ký Kinh Daonh 0314866590
                do Sở Kế hoạch và đầu tư Thành Phố Hồ Chí Minh cấp ngày
                12/02/2015
              </div>
            </div>
            <div
              className={`col-12 col-sm-12 col-md-3 col-lg-3 ${
                isTablet || isMobile ? 'w-100' : ''
              }`}
            >
              <div className="d-flex flex-row justify-content-start align-items-center gap-3">
                <div className="title-icon-name">Social media</div>
                <div>
                  <a
                    onClick={() =>
                      window.open(formData?.link_Youtube, '_blank').focus()
                    }
                  >
                    <YoutubeIconFooter />
                  </a>
                </div>
                <div>
                  <a
                    onClick={() =>
                      window.open(formData?.link_Facebook, '_blank').focus()
                    }
                  >
                    <FacebookIconFooter />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="bottom-bar"></div> */}
    </footer>
  );
};

export default Footer;
